import { C, fonts } from "../theme.js";
import { SectionLabel } from "./primitives.jsx";
import { STEPS } from "../content.js";

export const Process = ({ accent }) => (
  <section id="process" style={{ background: C.bg, padding: "140px 40px" }}>
    <div style={{ maxWidth: 1280, margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 24,
          marginBottom: 56,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <SectionLabel accent={accent}>// PROCESS</SectionLabel>
          <h2
            style={{
              margin: 0,
              fontFamily: fonts.serif,
              fontSize: "clamp(36px, 4.4vw, 56px)",
              fontWeight: 500,
              color: C.fg,
              letterSpacing: "-0.01em",
              lineHeight: 1.05,
            }}
          >
            How an engagement{" "}
            <em style={{ color: accent, fontStyle: "italic", fontWeight: 500 }}>unfolds.</em>
          </h2>
        </div>
        <p
          style={{
            margin: 0,
            fontFamily: fonts.mono,
            fontSize: 13,
            color: C.body,
            maxWidth: 360,
            lineHeight: 1.65,
          }}
        >
          From first call to production handoff, typically 8–16 weeks.
        </p>
      </div>

      <div style={{ position: "relative" }}>
        <div
          className="process-line"
          style={{
            position: "absolute",
            top: 32,
            left: "5%",
            right: "5%",
            height: 1,
            background: `linear-gradient(to right, transparent, ${accent}88, ${accent}88, transparent)`,
          }}
        />
        <div
          className="process-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: 16,
            position: "relative",
          }}
        >
          {STEPS.map((s, i) => (
            <div key={i} style={{ textAlign: "center", padding: "0 8px" }}>
              <div
                style={{
                  width: 64,
                  height: 64,
                  margin: "0 auto",
                  borderRadius: 999,
                  border: `1px solid ${accent}`,
                  display: "grid",
                  placeItems: "center",
                  background: C.bg,
                  position: "relative",
                  zIndex: 2,
                  fontFamily: fonts.serif,
                  fontStyle: "italic",
                  fontSize: 22,
                  fontWeight: 500,
                  color: accent,
                  boxShadow: `0 0 20px ${accent}33`,
                }}
              >
                {s.n}
              </div>
              <h4
                style={{
                  margin: "20px 0 10px",
                  fontFamily: fonts.serif,
                  fontSize: 20,
                  fontWeight: 500,
                  color: C.fg,
                  letterSpacing: "-0.005em",
                }}
              >
                {s.t}
              </h4>
              <p style={{ margin: 0, fontFamily: fonts.sans, fontSize: 13, lineHeight: 1.6, color: C.body }}>
                {s.b}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
